export const bcLedgerRouting: BCLedgerRouting[] = [
  {
    path: "Misc",
    category: "Misc",
    isBackground: false,
  },
  {
    path: "Samples",
    category: "Merch",
    isBackground: false,
  },
  {
    path: "backlogdetails",
    category: "portal",
    isBackground: false,
  },
  {
    path: "GPAdjustments",
    category: "Commission Adj",
    isBackground: false,
  },
  {
    path: "Freight",
    category: "Freight",
    isBackground: false,
  },
  {
    path: "freightdetail",
    category: "portal",
    isBackground: false,
  },
  {
    path: "SalesCommissions",
    category: "portal",
    isBackground: false,
  },
  {
    path: "Adjustments",
    category: "portal",
    isBackground: false,
  },
  {
    path: "NetsChargedorCredited",
    category: "portal",
    isBackground: false,
  },
  {
    path: "Chargebacks",
    category: "portal",
    isBackground: false,
  },
  {
    path: "YTDGP",
    category: "portal",
    isBackground: false,
  },
  {
    path: "CommissionsPaidTotal",
    category: "Commission Payments",
    isBackground: true,
  },
  {
    path: "TotalSalesCommissionsAdjustments",
    category: "portal",
    isBackground: true,
  },
  {
    path: "TotalAPMisc",
    category: "portal",
    isBackground: true,
  },
];

export interface BCLedgerRouting {
  path: string;
  category: string;
  isBackground: boolean;
}
